import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.scrollToFirstError();
  }

  scrollToFirstError() {
    const firstInvalidField = this.element.querySelector('.is-invalid');

    if (firstInvalidField) {
      firstInvalidField.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      firstInvalidField.focus();
    }
  }
}